import React, { Component } from 'react'
import Header from '../Header'
import './XVIw.css'

class XVIw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXVIw">
                    <p className="textXVIw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default XVIw